import './MainPageSub04_3.scss';
import fig_search from '../images/home/fig_search.png'; 
import React, { useEffect } from 'react';

const MainPageSub04_3 = () => {

    
    //=====================================================================
    
    return (
        <div className="MainPageSub04_3">
            <section className='sec-main'>

                <section className='sec-sub1'>
                 
                    <article className='art-main'>

                        <p className="heading-3 title2">멘토는 존재하는가?</p>
                        <p className="heading-3">시간관리를 통한 훈련총량으로 공부력을 만들다!</p>
      

                        <section className="description2">
                            <p>
                                지금부터는 시간관리 즉, 시간의 배치와 배정 그리고 멘토와의 접촉시간을 늘리는데 집중합니다.<br />
                                무엇을 어떻게 해야 하는지를 알고 있는지 혹은 모른다면 누군가의 도움을 받고 있는지를 점검합니다.
                            </p>
                        </section>

                        <section className="description2">
                            <p>
                            참고로, 학습총량을 늘린다는 것은 <br />
                            <mark>예습과 복습의 시간, 선행의 시간을 얼마나 누적 했느냐</mark>와 
                            <mark>난이도를 어느 정도까지 향상시키고 있느냐</mark>의 문제입니다.
                            </p>
                        </section>


                        <ul className="analysis-list">
                            <li>예습은 무엇인가?</li>
                            <li>복습은 무엇인가?</li>
                            <li>선행은 무엇인가?</li>
                        </ul>

                        <section className="description2">
                            <p>
                                <mark>예습이란</mark> 읽어낸 후 설명이 안 되어 이해가 되지 않는 부분을 찾아내어 정리하는 행위이며<br />
                                <mark>복습이란</mark> 찾아낸 행위 후에도 헷갈리거나 실수가 잦은 부분을 다시한번 점검하는 행위이며<br />
                                <mark>선행이란</mark> 적어도 한학기 혹은 3년 남짓의 예습과 복습의 과정을 거쳐 난이도별 문제풀이의 
                                총량을 3회 남짓 반복한 행위를 의미합니다.
                            </p>
                        </section>

                        <section className="description2">
                            <p>
                                물론, <mark>유형별 예/복습과 선행하는 방법은 다르다!!</mark> <br />
                                해당 내용은, 유형진단분석 후 <mark>학업역량 종합평가 보고서에서 제시</mark>해 드립니다.<br />
                                학업역량 종합평가 보고서를 확인 후 <mark>개인맞춤 미션</mark>을 통해 부족한 영역을 차곡차곡 체워나가길 바랍니다.

                            </p>
                        </section>


                    </article>


                 
                  
                </section>

            </section>
        </div>
    );
};

export default MainPageSub04_3;
